var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.304 12.946-1.179-1.178 1.179-1.179A4.167 4.167 0 1 0 9.41 4.697L8.233 5.875 7.054 4.697l1.179-1.179a5.833 5.833 0 0 1 8.25 8.25l-1.18 1.178Zm-2.357 2.357-1.179 1.179a5.833 5.833 0 1 1-8.25-8.25l1.179-1.178 1.178 1.178-1.178 1.179a4.167 4.167 0 0 0 5.892 5.892l1.179-1.178 1.178 1.178Zm-.59-8.839 1.179 1.179-5.893 5.892-1.178-1.178 5.892-5.893Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLink);
export default __webpack_public_path__ + "static/media/edit-link.83966b5ac0989659b567cbf4b01983bf.svg";
export { ForwardRef as ReactComponent };